import { Record } from 'immutable';

const EventCollisionInfoVendorRecord = Record({
  chain: '',
  brand: '',
  property_id: '',
  property_name: '',
  property_address: '',
  property_zip: '',
  property_city: '',
  property_state: '',
  property_country: '',
  edited_vendor_code: '',
});

export class EventCollisionInfoVendor extends EventCollisionInfoVendorRecord {
  chain: string;
  brand: string;
  property_id: string;
  property_name: string;
  property_address: string;
  property_zip: string;
  property_city: string;
  property_state: string;
  property_country: string;
  edited_vendor_code: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/event-collision-info-vendor.ts